module.exports = __webpack_public_path__ + "img/3.81458c16.png";